module.exports = __webpack_public_path__ + "assets/img/gift-4-d-33401dbc.png";